import styled, { css } from 'styled-components'
import { flags, i18NextKeyForLocalStorage, languages } from '../i18n'
import * as React from 'react'
import { FunctionComponent, useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'
import IconToc from '../assets/images/icons/icon-toc.svg'
import IconClose from '../assets/images/icons/icon-close.svg'
import Div100vh from 'react-div-100vh'
import { theme } from '../theme/theme'

/**
 * Base Layout for all pages
 *
 * @param props
 * @constructor
 */
export const Layout: FunctionComponent = (props) => {
  return (
    <Div100vh>
      {/* A "layout route" is a good place to put markup you want to
          share across all the pages on your site, TrackListItemStyledke navigation. */}
      <Header />

      {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
      <main>
        <Outlet />
      </main>
    </Div100vh>
  )
}

const FirstComponentStyled = styled.div`
  color: ${props => props.theme.fontColor};
`

export const FirstComponent: FunctionComponent = (props) => {
  console.log('hello world')
  return (
    <FirstComponentStyled></FirstComponentStyled>
  )
}

export const HiddenSpanStyled = styled.span`
  position: absolute;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(0px 0px 99.9% 99.9%);
  overflow: hidden;
  height: 1px;
  width: 1px;
  padding: 0;
  border: 0;
  top: 50%;
`

export const TocLinkStyled = styled.button`
  display: block;
  width: calc(21px * 3);
  height: 48px;
  background: url(${IconToc}) no-repeat center center;
  position: absolute;
  top: -48px;
  left: 0;

  &:hover {
    /* color svg #303E52: here we can create new filter settings: https://codepen.io/sosuke/pen/Pjoqqp */
    filter: invert(20%) sepia(58%) saturate(378%) hue-rotate(175deg) brightness(85%) contrast(84%);
  }
`

export const toggleStyledHeight = '20px'
export const ToggleStyled = styled.label<{ disabled?: boolean }>`
  //label {
  position: relative;
  display: inline-block;
  width: 40px;
  height: ${toggleStyledHeight};
  //}

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff; // background inactive
    transition: 0.3s ease-out;
    border-radius: 20px;
  }

  //strong {
  //  position: absolute;
  //  left: 100%;
  //  width: max-content;
  //  height: 100%;
  //  line-height: 30px;
  //  margin-left: 10px;
  //  cursor: pointer;
  //}

  span:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 1px;
    bottom: 1px;
    background-color: #818995; //${props => props.theme.colorBackgroundDarkblue};
    border-radius: 50%;
    transition: 0.3s;
  }

  input:checked + span {
    background-color: #ffffff;

    :before {
      background-color: ${props => props.theme.colorBackgroundDarkblue};
    }
  }

  input:checked + span:before {
    transform: translateX(20px);
  }

  ${props => props.disabled === true && css`
    pointer-events: none;

    span:before {
      opacity: 0.3;
    }

    input:checked + span {
      background-color: transparent;

      &:after {
        content: "";
        position: absolute;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border-radius: 20px;
        top: 0;
        left: 0;
        border: 1px solid #B9BEC4;
      }
    }
  `}
`

export const Toggle: FunctionComponent<{ label: string, toggled: boolean, onClick?: (isToggled: boolean) => void, disabled?: boolean }> = ({ label, toggled, onClick, disabled = false }) => {
  const [isToggled, toggle] = useState(toggled)

  const onClickHandler = () => {
    toggle(!isToggled)
    onClick(!isToggled)
  }

  return (
    <ToggleStyled disabled={disabled}>
      <input type="checkbox" disabled={disabled} defaultChecked={isToggled} onClick={onClickHandler} />
      <span></span>
      {/*<strong>{label}</strong>*/}
    </ToggleStyled>
  )
}

const createTrackListBackgroundOpacity = () => {
  let str = ''
  let index = 1
  for (let i = 1; i > 0; i -= 0.08) {
    str += `&:nth-child(${index}):before { opacity: ${i}; }`
    index++
  }
  return str
}

export const TrackListItemStyled = styled.li<{ state?: string }>` // active, past, inactiv
  position: relative;
  height: 48px;
  font-family: 'PT Serif', serif;
  font-size: 18px;
  line-height: 1.3em;
  color: #000000;

  a {
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none;
    color: #000000;
    overflow: hidden;
    word-break: break-word;

    &:hover {
      // todo define
      color: ${props => props.theme.colorFontDarkBlue};
    }

    &:active {
    }
  }

  &:before {
    content: ' ';
    pointer-events: none;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -999;
    top: 0;
    left: 0;
    background-color: ${props => props.theme.colorTrackListBackgroundNormal};
  }

  span:first-child { // number icon
    position: absolute;
    display: inline-block;
    width: 36px;
    height: 36px;
    margin: 6px 11px 13px 13px;
    padding-top: 10px;
    text-align: center;
    background-color: #ffffff;
    font-family: 'Open Sans', serif;
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
    color: #000000;
  }

  span:nth-child(2) { // text
    height: 48px;
    display: flex;
    align-items: center;
    margin-left: 60px;
    margin-right: 40px;
    line-height: 1em;
    word-break: break-word;
    overflow: visible;
  }

  span:nth-child(3) { // animation PeakMeterStyled
    position: absolute;
    right: 20px;
    top: 13px;
  }

  ${createTrackListBackgroundOpacity()} // state: normal

  ${props => props.state === 'active' && css`
    a {
      color: ${props => props.theme.colorFontTrackListItemActive};
      font-weight: bold;
    }

    &:before {
      background-color: ${props => props.theme.colorTrackListBackgroundActive};
    }

    span:first-child {
      color: #ffffff;
      background-color: ${props => props.theme.colorBackgroundDarkblue};
    }
  `}

  ${props => props.state === 'past' && css`
    a {
      color: rgba(0, 0, 0, 0.6);
    }

    &:before {
      background-color: ${props => props.theme.colorTrackListBackgroundPast};
    }
  `}
`

export const TrackListStyled = styled.ul`
  height: 100%;
  flex: 1;
`

const HeaderStyled = styled.header<{ hasBackground: boolean, hasBorderBottom: boolean }>`
  position: relative;
  width: 100%;
  height: ${props => props.theme.headerHeight}px;
  background-color: ${props => props.theme.colorGrey};

  ${props => props.hasBackground === false && css`
    background-color: ${props => props.theme.colorBackgroundFrontPage};
    border: none;
  `}
  ${props => props.hasBorderBottom === true && css`
    border-bottom: 1px solid #ffffff;
  `}
`

export const PStyled = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  line-height: 14px;
  /* or 117% */
  text-align: center;
  color: ${props => props.theme.colorFontDarkBlue};
  opacity: 0.76;

  a {
    text-decoration: underline;
    color: ${props => props.theme.colorFontDarkBlue};
  }
`

export const TextButtonStyled = styled.button`
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${props => props.theme.colorFontDarkBlue};
  padding: 12px 25px;
  box-shadow: 2px 2px 8px #B3A68B, 0px 0px 94px #EFEBE3;
  border-radius: 70px;
  background-color: #ffffff;
  /* Auto layout */
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  min-width: 203px;
  //gap: 8px;
`
export const TextButtonStyledContainer = styled.div`
  position: relative;
  text-align: center;

  ${TextButtonStyled} {
    //position: absolute;
    //bottom: 22px;
    //left: 50%;
    //transform: translate(-50%, 0);
  }
`

export const Header: FunctionComponent = (props) => {
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const path = location.pathname.slice(3) // remove lang of path we always have in path (e.g. /en or /en/
  const isFrontPage = path === '' || path === '/'
  const isOverviewPage = path.indexOf('overview') !== -1 // we no longer have overview

  return (
    <HeaderStyled hasBackground={!isFrontPage} hasBorderBottom={isOverviewPage}>
      {/*{(!isFrontPage && !isOverviewPage) && <TocLinkStyled to={`/${i18n.resolvedLanguage}/overview`}><HiddenSpanStyled>Overview</HiddenSpanStyled></TocLinkStyled>}*/}
      {/*{(!isFrontPage && isOverviewPage) && <TocLinkStyled to={`/${i18n.resolvedLanguage}/station/${currStationData?.id}`}><HiddenSpanStyled>Overview</HiddenSpanStyled></TocLinkStyled>}*/}
      <LanguageMenu></LanguageMenu>
      {/*      <Link to={`/${i18n.resolvedLanguage}/nothing-here`}>Link to nothing</Link>*/}
    </HeaderStyled>
  )
}


export const NavLinkStyled = styled(Link)<{ type: string, disabled: boolean }>` //previous, next
  width: 48px; //32px is image
  height: 48px; //32px is image
  position: absolute;
  top: calc(50% - ${props => props.theme.headerHeight}px - 8px);
  filter: drop-shadow(3px 5px 3px rgba(48, 62, 82, 0.4));

  img {
    width: 48px;
    position: absolute;
    top: 8px;
    object-position: right;
  }

  ${props => props.disabled === true && css`
    pointer-events: none;
    opacity: 0;
  `}
  ${props => props.type === 'previous' && css`
    left: 0px;
  `}
  ${props => props.type === 'next' && css`
    right: 0px;
  `}

  //&:after { // todo is it possible to make a round selection area?
  //  content: " ";
  //  position: absolute;
  //  top: -8px;
  //  left: -8px;
  //  width: 60px;
  //  height: 60px;
  //  border-radius: 60px;
  //  border: 1px solid red;
  //  //background: red;
  //}
`

/**
 * Apples Media queries:
 * @media only screen and (max-width: 1068px) {
 * @media only screen and (max-width: 734px) {
 * @media only screen and (min-width: 1441px) {
 *
 */

export const FrontHeaderStyled = styled.div<{ small?: boolean }>`
  height: ${props => props.small ? props.theme.frontHeaderSmallHeight + 'px' : '30%'};
  min-height: ${props => props.small ? props.theme.frontHeaderSmallHeight + 'px' : '172px'};
  display: flex;
  width: 100%;
  background-color: ${props => props.theme.colorBackgroundFrontPage};
  justify-content: center;
  align-items: center;
  //height: clamp(173pxpx, 5vh, 40px);
  //border: 1px solid brown;

  ${props => props.small === true && css`
    border-bottom: 1px solid #ffffff;
  `}
  > div {
    //border: 1px solid orange;
    display: flex;
    column-gap: ${props => props.small ? '15px' : '19px'};
    //column-gap: 0;
    position: absolute;
    margin-top: ${props => props.small ? 'auto' : '-14px'};
    margin-bottom: auto;
  }

  a {
    text-decoration: none;
    position: absolute;
    margin-top: auto;
    margin-bottom: auto;

    > div {
      display: flex;
      column-gap: ${props => props.small ? '15px' : '19px'};
    }
  }

  h1 {
      // margin-left: ${props => props.small ? '15px' : '19px'}; for older mobile safari
    column-gap: ${props => props.small ? '15px' : '19px'};
  }

  img {
    //border: 1px solid red;
    padding-left: ${props => props.small ? '0px' : '5px'};
    width: auto;
    height: ${props => props.small ? '113px' : '163px'};
    margin-top: ${props => props.small ? '0px' : '-6px'};
  }

  span {
    display: block;
    line-height: 1.2em;
    color: ${props => props.theme.colorFontDarkBlue};
  }

  span:first-child {
    font-weight: bold;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    letter-spacing: 0.08em;
    margin-top: ${props => props.small ? '24px' : '25px'};
    margin-left: 2px;
  }

  span:nth-child(2) {
    font-family: 'PT Serif', serif;
    font-weight: normal;
    font-size: ${props => props.small ? '22.35px' : '32.27px'};
    line-height: 1.2em;
    margin-top: ${props => props.small ? '12px' : '24px'};
  }

  span:nth-child(3) {
    font-family: 'PT Serif', serif;
    font-weight: bold;
    font-size: ${props => props.small ? '22.35px' : '32.27px'};
    margin-left: 1px;
    margin-top: ${props => props.small ? '-5px' : '-7px'};
  }
`

export const FrontPageContainerStyled = styled.div`
  position: relative;
  height: 100%;
  //border: 4px dashed blueviolet;
  //display: flex;
  //flex-direction: column;

  > :first-child {
    //border: 2px solid blue;
    position: absolute;
    top: 0;
    height: 28%;
  }

  > :nth-child(2) {
    //border: 2px solid yellow;
    position: absolute;
    //overflow: hidden;
    top: max(28%, 171px); // we use 171 instead of 172px height of header to prevent scrollbars which we get because of percentage height
    height: 72%;
  }

  //> * {
  //  flex: 1 1 0;
  //}

`

export const FrontPageContentLinePleasePaddingStyled = styled.div`
  `
export const FrontPageContentLinePleaseStyled = styled.div`
  position: relative;

  > div {
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    bottom: 0;
    //border: 1px solid green;
    width: auto;
    text-align: center;
    height: 55px;

    //margin-top: 3%;
  }


  img {
    position: absolute;
    top: 11px;

    &:nth-of-type(1) {
      left: calc(50% - 108px - 8px); //icon has 44px
    }

    &:nth-of-type(2) {
      left: calc(50% + 62px + 8px);
    }
  }

  span {
    position: relative;
    display: inline-block;
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    padding-top: 23px;
    /* identical to box height */
    text-align: center;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${props => props.theme.colorBackgroundDarkblue};

    &:before {
      content: "";
      position: absolute;
      width: 35px;
      height: 0px;
      top: calc(10px + 23px);
      left: calc(-35px - 8px);
      border-top: 1px solid ${props => props.theme.colorBorderGrey};
    }

    &:after {
      z-index: 111;
      content: "";
      position: absolute;
      width: 35px;
      height: 0px;
      top: calc(10px + 23px);
      left: calc(100% + 8px - 2px);
      border-top: 1px solid ${props => props.theme.colorBorderGrey};
    }
  }
`

export const FrontPageImageContainerStyled = styled.div`
  position: relative;
  text-align: center;

  img {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: auto;
  }
`


export const FrontPageCookieConsentPContainerPaddingStyled = styled.div`
  `
export const FrontPageCookieConsentPContainerStyled = styled.div`
  position: relative;

  ${PStyled} {
    position: relative;
    width: 100%;
    padding: 0 20px 0 20px;
    margin-top: 3px;
    margin-bottom: 15px;
    //left: 50%;
    //transform: translate(-50%, 0);
    //max-width: 400px;
  }
`

export const ImprintContainerStyled = styled.div`
  width: 100%;
  flex: 1 0 21px;
  height: 21px;
  min-height: 21px;
  max-height: 21px;
  background-color: ${props => props.theme.colorBackgroundFrontPageImprint};
  display: flex;
  justify-content: center;
  div {
    display: flex;
    height: 21px;
    vertical-align: center;
    align-items: center;
  }
  span, a {
    font-family: 'Open Sans', sans-serif;
    display: inline;
    text-decoration: none;
    font-weight: 600; // semi-bold
    font-size: 10px;
    line-height: 100%;
    letter-spacing: 0.08em;
    color: #ffffff;
  }
`

export const FrontPageContentStyled = styled.div`
  position: relative;
  width: 100%;
  border-top: 1.5px solid #ffffff;
  background-color: ${props => props.theme.colorBackgroundBeige2};
  display: flex;
  flex-direction: column;

  > * {
    //border: 1px solid green;

  }

  ${FrontPageContentLinePleaseStyled} {
    flex: 1 0 55px;
    min-height: 58px; // was 75
  }

  ${FrontPageContentLinePleasePaddingStyled} {
    flex: 1 0 0;
    max-height: 20px;
  }
  ${FrontPageCookieConsentPContainerPaddingStyled} {
    flex: 1 0 0;
    max-height: 27px;
  }

  ${FrontPageImageContainerStyled} {
    flex: 2;

    img {
      //position: absolute;
      //top: 2.55%;
      //bottom: 88.31%;
    }
  }


  ${FrontPageCookieConsentPContainerStyled} {
    flex: 2;
    margin: 0 10px 0 10px;
  }

  ${TextButtonStyledContainer} {
    flex: 3;
    min-height: 50px;
    margin-bottom: 10px;
  }

`

export const AudioPlayerContainerStyled = styled.div`
  position: relative;
  //height: 100%; don't set this, if set sticky wont work on smaller screen heights
  display: flex;
  flex-direction: column;
`

export const TrackListContainerStyled = styled.div`
  position: relative;
  height: calc(100%); //- 151px
  overflow: scroll;
  display: flex;
  flex-direction: column;

  &:before {
    content: '';
    position: fixed; // todo move line to header element instead of fixed
    top: 48px;
    width: 100%;
    left: 0;
    height: 1px;
    border-top: 1px solid #ffffff;
    pointer-events: none;
  }
`


export const StationPageHeaderStyled = styled.div`
  width: 100%;
  height: 78px;
  background-color: ${props => props.theme.colorBackgroundDarkblue};
  position: relative;

  h1 {
    position: relative;
    color: #ffffff;

    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      position: absolute;
      top: 12px;
      left: 15px;
      margin-right: 45px;
      font-family: 'Open Sans', sans-serif;
      font-weight: 700;
      font-size: 24px;
      line-height: 24px;
      text-align: center;
    }

    span:nth-child(2) {
      height: 48px;
      display: flex;
      align-items: center;
      margin-left: 82px;
      margin-right: 18px;
      margin-top: 14px;
      font-family: 'PT Serif', serif;
      font-size: 24px;
      line-height: 24px;
      font-weight: 700;
      color: #ffffff;
      word-break: break-word;
      overflow: visible;

      &:before {
        content: ' ';
        position: absolute;
        top: 0px;
        left: 59px;
        height: 50px;
        width: 0px;
        border-right: 1px solid #ffffff;
      }
    }
  }
`

export const ImageContainerStyled = styled.div`
  flex: 1; /* let it take free all space */
  height: 100%;
  background-color: ${theme.colorBackgroundDarkblue};
  position: relative;
  overflow: hidden;
}
`
export const StationPageImageStyled = styled.div<{ offset: number, srcSmall: string, srcSmall2x: string, srcMedium: string, srcMedium2x: string, srcLarge2x: string, srcLarge: string, positionY: string }>`
  position: absolute;
  transition: left 0.4s ease, opacity 1s ease;
  left: ${props => (['calc(-100% - 2px)', '0', 'calc(100% + 2px)'][props.offset + 1])};
  opacity: ${props => (props.offset ? 0 : 1)};
  width: 100%;
  height: 100%;
  background-image: url(${props => props.srcLarge});
  background-repeat: no-repeat;
  background-position: center ${props => props.positionY ? props.positionY : 'center'};
  background-size: cover;

  @media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx), (min-resolution: 144dpi) {
    background-image: url(${props => props.srcLarge2x});
    //border: 1px solid pink;
  }

  @media only screen and (max-width: 1068px) {
    background-image: url(${props => props.srcMedium});
  }

  @media (max-width: 1068px) and (-webkit-min-device-pixel-ratio: 1.5), (max-width: 1068px) and (min-resolution: 1.5dppx), (max-width: 1068px) and (min-resolution: 144dpi) {
    background-image: url(${props => props.srcMedium2x});
    //border: 1px solid green;
  }


  @media (max-width: 734px) {
    background-image: url(${props => props.srcSmall});
    //border: 1px solid brown;
  }

  @media (max-width: 734px) and (-webkit-min-device-pixel-ratio: 1.5), (max-width: 734px) and (min-resolution: 1.5dppx), (max-width: 734px)and (min-resolution: 144dpi) {
    background-image: url(${props => props.srcSmall2x});
    //border: 1px solid yellow;
  }
`

export const MainPageContainerStyled = styled.div`
  height: calc(100% - ${props => props.theme.playerControlsHeight}px);
  min-height: calc(${props => props.theme.minHeight}px - ${props => props.theme.playerControlsHeight}px);
  display: flex;
  flex-direction: column;

  //img {
  //  flex: 1 1 auto;
  //  object-fit: cover;
  //  object-position: center center;
  //  width: 100%;
  //  height: 100%;
  //}
`

export const CloseIconButtonStyled = styled.button`
  position: absolute;
  top: calc(-3px - 12px);
  right: calc(-3px - 12px);

  width: 48px;
  height: 48px;
  background: url(${IconClose}) center center no-repeat;

  &:hover {
    // todo define
    /* color svg #303E52: here we can create new filter settings: https://codepen.io/sosuke/pen/Pjoqqp */
    filter: invert(20%) sepia(58%) saturate(378%) hue-rotate(175deg) brightness(85%) contrast(84%);
  }
`


export const ContentContainerStyled = styled.div`
  position: relative;
  max-width: 1024px;
  margin-left: auto;
  margin-right: auto;
`

export const CookieConsentHeaderStyled = styled.span`
  display: block;
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  margin-bottom: 16px;
  color: ${props => props.theme.colorFontColorCookieConsent};
`

export const CookieConsentStyled = styled.div`
  z-index: 99999;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  //height: 270px;
  background-color: ${props => props.theme.colorBackgroundLightGreyBlue};
  padding: 21px 23px 21px 24px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4);
  animation: fadein 0.3s ease-out;

  ${ContentContainerStyled} {
  }

  ul {
    li {
      position: relative;
      list-style-type: none;
      padding: 8px 50px 10px 0;
      color: ${props => props.theme.colorFontColorCookieConsent};

      &:before {
        content: "";
        border-top: 1px solid ${props => props.theme.colorBorderGrey};
        width: 100%;
        height: 1px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }

  ${ToggleStyled} {
    position: absolute;
    right: 0;
    top: calc(50% - (${toggleStyledHeight} / 2));
  }

  ${TextButtonStyled} {
  }
`

export const CookieConsent: FunctionComponent<{
  isUserExperienceCookiesAllowed: boolean,
  isOpen: boolean, onClose: () => void, onOkay: () => void, setIsUserExperienceCookiesAllowed(value: boolean): void
}> =
  ({ isUserExperienceCookiesAllowed, isOpen, onClose, onOkay, setIsUserExperienceCookiesAllowed }) => {
    const { t } = useTranslation()

    const toggleUserExperienceCookies = (state) => {
      setIsUserExperienceCookiesAllowed(state)
    }

    // const Animation = styled.div<{ state: string }>`
    //   transition: all 0.3s ease-out;
    //   opacity: ${({ state }) => (state === 'entered' ? 1 : 0)};
    // `
    return (
      <>
        {/*<Transition in={isOpen} timeout={0}>*/}
        {/*  {(state) => (*/}
        {/* state change: exited -> entering -> entered -> exiting -> exited */}
        {/* <Animation state={state}> */}
        {isOpen && (
          <CookieConsentStyled>
            <ContentContainerStyled>
              <CookieConsentHeaderStyled>{t('cookieConsentOverlay.title')}</CookieConsentHeaderStyled>
              <ul>
                <li><span dangerouslySetInnerHTML={{ __html: t('cookieConsentOverlay.setting1') }}></span><Toggle label="Toggle me" toggled={true} disabled={true} /></li>
                <li><span dangerouslySetInnerHTML={{ __html: t('cookieConsentOverlay.setting2') }}></span><Toggle label="Toggle me" toggled={isUserExperienceCookiesAllowed}
                                                                                                                  onClick={toggleUserExperienceCookies} /></li>
                <li><span dangerouslySetInnerHTML={{ __html: t('cookieConsentOverlay.setting3') }}></span></li>
              </ul>
              <TextButtonStyledContainer>
                <TextButtonStyled onClick={onOkay}>{t('ui.btnStart')}</TextButtonStyled>
              </TextButtonStyledContainer>
              <CloseIconButtonStyled onClick={onClose}></CloseIconButtonStyled>
            </ContentContainerStyled>
          </CookieConsentStyled>
        )}
        {/*// </Animation>*/}
        {/*)}*/}
        {/*</Transition>*/}
      </>
    )
  }


export const LanguageMenuItemStyled = styled.li<{ isActive?: boolean }>`
  position: relative;
  width: 100%;
  height: 48px;
  background: #F0EBE3;
  line-height: 19px;

  button {
    position: relative;
    border: none;
    padding: 0;
    width: 100%;
    height: 100%;
    color: ${props => props.theme.colorBackgroundDarkblue};
    font-family: 'Open Sans', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    text-align: left;
    background-color: #F0EBE3;

    ${props => props.isActive === true && css`
      background-color: #CDD2DA;
    `}
    &:hover {
      background-color: #ffffff;
      img {
        filter: drop-shadow(1px 1px 5px #303E5350);
      }
    }

    span {
      position: absolute;
      top: 15px;
      left: 10px;
    }

    img {
      pointer-events: none;
      position: absolute;
      right: 15px;
      top: 16px;
      width: 26px;
      height: auto;
    }
  }

`

export const LanguageMenuStyled = styled.ul`
  list-style-type: none;
  position: absolute;
  top: 0;
  right: 0;
  width: 115px;
  background: ${props => props.theme.colorGrey};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  z-index: 999;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 1px;

  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  animation: fadein 0.3s ease-out;

  ${LanguageMenuItemStyled} {
  }
`

export const LanguageMenuButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 57px;
  height: 48px;
  //border: 1px solid red;
  background-color: transparent;

  img {
    position: absolute;
    top: 16px;
    right: 15px;
    width: 26px;
    height: auto;
  }
`

// maybe helpful: https://dev.to/psideris89/internationalisation-in-react-2ahl
export const LanguageMenu: FunctionComponent = (props) => {

  const getSortedLanguages = () => {
    const sortedLanguages = [...languages]
    sortedLanguages.splice(languages.indexOf(i18n.resolvedLanguage), 1)
    sortedLanguages.unshift(i18n.resolvedLanguage)
    return sortedLanguages
  }

  const { t, i18n } = useTranslation()
  const ref = useRef<HTMLUListElement>(null)
  const location = useLocation()
  const navigate = useNavigate()
  const sortedLanguages = getSortedLanguages()

  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const checkIfClickedOutside = e => {
      // close menü if clicked outside
      if (isOpen && ref.current && !ref.current?.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', checkIfClickedOutside)
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  }, [isOpen])

  return (
    <>
      <LanguageMenuButton onClick={() => { setIsOpen(true)}} aria-label="select language"><img alt={i18n.resolvedLanguage} src={flags[i18n.resolvedLanguage]}></img></LanguageMenuButton>
      {isOpen && (
        <LanguageMenuStyled ref={ref}>
          {
            sortedLanguages.map((id) => (
              <LanguageMenuItemStyled key={id} isActive={i18n.resolvedLanguage === id}>
                <button key={id} aria-label={t(`languages.${id}`)}
                        onClick={() => {
                          if (i18n.resolvedLanguage == id) {
                            setIsOpen(false)
                            return
                          }
                          const oldPath = location.pathname.slice(3) // remove lang in path (e.g. /en or /en/), we always have lang in path.
                          const newPath = id + oldPath
                          navigate(newPath, { replace: true })
                          localStorage.setItem(i18NextKeyForLocalStorage, id)
                          i18n.changeLanguage(id)
                          setIsOpen(false)
                        }}
                >
                  <span>{t(`languages.${id}`)}</span>
                  <img alt={t(`languages.${id}`)} src={flags[id]}></img>
                </button>
              </LanguageMenuItemStyled>
            ))}
        </LanguageMenuStyled>
      )}
    </>
  )
}

export const PageNotFoundTextStyled = styled.div`
  p {
    margin-top: 40px;
    text-align: center;
    margin-bottom: 15px;
  }
`

export const PeakMeterStyled = styled.span`
  display: block;
  transform-origin: top left;
  width: 14px;
  height: 14px;

  rect {
    fill: #313e52;
  }
  rect:nth-child(1) {
    animation: iconPeakMeterFirstAnimation 1s linear infinite
  }

  rect:nth-child(2) {
    transform: translateY(90%);
    animation: iconPeakMeterSecondAnimation 1s linear infinite
  }

  rect:nth-child(3) {
    transform: translateY(70%);
    animation: iconPeakMeterThirdAnimation 1s linear infinite
  }

  @keyframes iconPeakMeterFirstAnimation {
    0% {
      transform: translateY(0%);
    }
    25% {
      transform: translateY(57%);
    }
    50% {
      transform: translateY(75%)
    }
    75% {
      transform: translateY(80%)
    }
  }
  @keyframes iconPeakMeterSecondAnimation {
    0% {
      transform: translateY(90%);
    }
    25% {
      transform: translateY(10%);
    }
    50% {
      transform: translateY(50%)
    }
    75% {
      transform: translateY(30%)
    }
  }
  @keyframes iconPeakMeterThirdAnimation {
    0% {
      transform: translateY(70%);
    }
    25% {
      transform: translateY(80%);
    }
    50% {
      transform: translateY(0%)
    }
    75% {
      transform: translateY(20%)
    }
  }
`

export const PeakMeterAnimation: FunctionComponent = (props) => {
  return (
    <PeakMeterStyled>
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
        <rect width="3.52" height="14"/>
        <rect x="5.24" y="0" width="3.52" height="14"  />
        <rect x="10.48" y="0" width="3.52" height="14"  />
      </svg>
      {/* <defs>
        <clipPath id="clip0_1024_92428">
          <rect width="14" height="14" fill="white"/>
        </clipPath>
      </defs>*/}
    </PeakMeterStyled>
  )
}
